module.exports = __webpack_public_path__ + "static/media/lang_pink.d0aa985b.svg";